import React from 'react';
import { createUseStyles } from 'react-jss';
import cx from 'classnames';
import { H2 } from '../Text';
import { SegmentContainer } from '../Segment';
import { Theme } from '_lib/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    fontFamily: theme.typography.fontFamily,
  },
  content: {
    padding: 16,
    width: '100%',
    boxSizing: 'border-box',
  },
  tags: {
    display: 'flex',
    marginBottom: (props: TagListProps) => props.margin || 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    fontSize: 16,
    lineHeight: '18px',
    color: theme.colors.bodyTextLight,
  },
  tagItem: {
    paddingRight: 16,
    display: 'flex',
    alignItems: 'center',
  },
  tagItemPill: {
    color: theme.colors.primary,
  },
  tagPill: {
    width: 6,
    height: 6,
    marginRight: 5,
    borderRadius: 99,
    background: theme.colors.primary,
  },
}));

type TagListProps = {
  isPillShown?: boolean;
  tags: React.ReactNode[];
  margin?: number;
};

const TagList = (props: TagListProps) => {
  const { isPillShown = false, tags } = props;
  const classes = useStyles(props);

  return (
    <div className={cx(classes.tags)}>
      {tags.map((item, i) => (
        <div
          key={i}
          className={cx(classes.tagItem, {
            [classes.tagItemPill]: isPillShown,
          })}
        >
          {isPillShown && <div className={classes.tagPill} />}
          <div>{item}</div>
        </div>
      ))}
    </div>
  );
};

type CardProps = {
  title: string;
  meta: React.ReactNode[];
  tags: React.ReactNode[];
  onClick?: () => void;
};

const Card = (props: CardProps) => {
  const classes = useStyles(props);
  const { title, meta, tags, onClick } = props;

  return (
    <div className={classes.container}>
      <SegmentContainer onClick={onClick}>
        <div className={classes.content}>
          <TagList tags={tags} isPillShown margin={5} />
          <H2 margin={5}>{title}</H2>
          <TagList tags={meta} />
        </div>
      </SegmentContainer>
    </div>
  );
};

export default Card;
